import React from 'react';

import inboxService from 'venuescanner-js/react/components/Inbox/services/inboxService';
import { ObserverIntersection } from 'venuescanner-js/vanilla/widgets/intersectionObserver';

import Loading from 'venuescanner-js/react/components/Inbox/components/Objects/Loading';
import { MemoizedEnquiryThumbnail } from 'venuescanner-js/react/components/Inbox/components/Enquiry/EnquiryThumbnail';

let currentModeButton = null;
const EnquiriesPanel = ({ enquiriesLoading, enquiriesAvailable, threads }) => {
  const loadMore = () => inboxService.more();
  const enquiries = threads.map((thread, index) => (
    <MemoizedEnquiryThumbnail key={thread.data()._id + index} thread={thread} />
  ));

  return (
    <div className='enquiries-panel'>
      {enquiries}
      {enquiriesAvailable ? (
        enquiriesLoading ? (
          <div className='enquiry-thumbnail__loader'>
            <Loading />
          </div>
        ) : (
          <span
            style={{
              display: 'block',
              height: '2px',
            }}
            ref={el => {
              if (el && el !== currentModeButton) {
                ObserverIntersection(el, { method: loadMore, onlyOnce: true });
                currentModeButton = el;
              }
            }}
          />
        )
      ) : null}
    </div>
  );
};

export default EnquiriesPanel;
